import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "../../firebase";
import {
  doc,
  getDoc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";
// PDF library
import jsPDF from "jspdf";

export default function AdminFormReviewPage() {
  const { userId, docId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDoc = async () => {
      const ref = doc(db, "users", userId, "complianceDocs", docId);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        setData({ id: snap.id, ...snap.data() });
      }
      setLoading(false);
    };
    fetchDoc();
  }, [userId, docId]);

  const markVerified = async () => {
    const ref = doc(db, "users", userId, "complianceDocs", docId);
    await updateDoc(ref, {
      verified: true,
      status: "verified",
      verifiedAt: serverTimestamp(),
    });
    alert("Form marked as verified.");
    navigate(-1);
  };

  const markRejected = async () => {
    const ref = doc(db, "users", userId, "complianceDocs", docId);
    await updateDoc(ref, {
      verified: false,
      status: "rejected",
      verifiedAt: serverTimestamp(),
    });
    alert("Form marked as rejected.");
    navigate(-1);
  };







 const downloadPdf = () => {
  if (!data) return;

  const pdf = new jsPDF("p", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();

  let y = 20;

  /* ----------------------------
     HEADER WITH CCR LOGO + TITLE
  ----------------------------- */

  // Add logo — adjust path to your actual logo file
  try {
    // If your logo is PNG in assets folder: import at top of file then use here
    // pdf.addImage(ccrLogo, "PNG", 15, 10, 30, 20);
  } catch (e) {
    console.warn("Logo failed to load:", e);
  }

  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(16);
  pdf.text("Convalesce Care & Recruitment Ltd-UK", pageWidth / 2, 18, {
    align: "center",
  });

  pdf.setFontSize(13);
  pdf.text("New Starter Payroll Form", pageWidth / 2, 26, { align: "center" });

  y = 40;
  pdf.setFontSize(10);
  pdf.setFont("helvetica", "normal");
  pdf.text(`User: ${userId}`, 15, y);
  y += 5;
  pdf.text(`Document ID: ${docId}`, 15, y);
  y += 10;

  /* --------------
     Helper blocks
  --------------- */
  const addSection = (title) => {
    if (y > 265) {
      pdf.addPage();
      y = 20;
    }
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(12);
    pdf.text(title, 15, y);
    y += 7;
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(10);
  };

  const addField = (label, value) => {
    if (y > 275) {
      pdf.addPage();
      y = 20;
    }
    pdf.setFont("helvetica", "bold");
    pdf.text(`${label}:`, 15, y);
    pdf.setFont("helvetica", "normal");
    pdf.text(String(value || "-"), 60, y);
    y += 6;
  };

  /* ----------------------------
     SECTION 1: PERSONAL DETAILS
  ----------------------------- */
  addSection("1. Personal Details");
  addField("Full Name", data.fullName);
  addField("Date of Birth", data.dob);
  addField("Address Line 1", data.addressLine1);
  addField("Address Line 2", data.addressLine2);
  addField("Postcode", data.postcode);
  addField("Phone Number", data.phone);
  addField("Email", data.email);
  addField("National Insurance No.", data.niNumber);

  /* ----------------------------
     SECTION 2: HMRC DECLARATION
  ----------------------------- */
  addSection("2. HMRC Starter Declaration");
  let declarationText = data.starterDeclaration;
  if (declarationText === "A") {
    declarationText =
      "A – First job since 6 April, no taxable state benefits.";
  } else if (declarationText === "B") {
    declarationText =
      "B – Not first job since 6 April OR receiving a state benefit.";
  } else if (declarationText === "C") {
    declarationText =
      "C – Has another job and/or receives a pension.";
  }
  addField("Starter Declaration", declarationText);

  /* ----------------------------
     SECTION 3: STUDENT LOANS
  ----------------------------- */
  addSection("3. Student Loan");
  addField(
    "Has Student Loan",
    data.hasStudentLoan === "yes" ? "Yes" : "No"
  );
  if (data.hasStudentLoan === "yes") {
    addField("Loan Plan", data.studentLoanPlan);
    addField(
      "Postgraduate Loan",
      data.hasPostgradLoan === "yes" ? "Yes" : "No"
    );
  }

  /* ----------------------------
     SECTION 4: RIGHT TO WORK
  ----------------------------- */
  addSection("4. Right to Work in the UK");
  addField("Share Code", data.rightToWorkShareCode);

  /* ----------------------------
     SECTION 5: BANK INFORMATION
  ----------------------------- */
  addSection("5. Bank Information");
  addField("Account Holder", data.bankAccountName);
  addField("Bank Name", data.bankName);
  addField("Sort Code", data.sortCode);
  addField("Account Number", data.accountNumber);
  addField("Roll Number", data.rollNumber);

  /* ----------------------------
     SECTION 6: EMERGENCY CONTACT
  ----------------------------- */
  addSection("6. Emergency Contact");
  addField("Name", data.emergencyContactName);
  addField("Relationship", data.emergencyContactRelationship);
  addField("Phone", data.emergencyContactPhone);

  /* ------------------------------------------
     SECTION 7: WORKING TIME & OTHER EMPLOYMENT
  ------------------------------------------- */
  addSection("7. Working Time / Other Employment");
  addField(
    "Hours Restricted",
    data.hoursRestricted === "yes" ? "Yes" : "No"
  );
  if (data.hoursRestricted === "yes") {
    addField("Restriction Details", data.hoursDetails);
  }
  addField(
    "Other Employment",
    data.otherEmployment === "yes" ? "Yes" : "No"
  );
  if (data.otherEmployment === "yes") {
    addField("Other Employment Details", data.otherEmploymentDetails);
  }

  /* ----------------------------
     SECTION 8: DECLARATION
  ----------------------------- */
  addSection("8. Declaration");
  addField(
    "Declaration Accepted",
    data.declarationAccepted ? "Yes" : "No"
  );

  /* ----------------------------
     SECTION 9: ADMIN SECTION
  ----------------------------- */
  addSection("9. Admin Review");
  addField("Status", data.status || "submitted");
  addField("Verified", data.verified ? "Yes" : "No");
  addField(
    "Verified At",
    data.verifiedAt?.toDate
      ? data.verifiedAt.toDate().toLocaleString()
      : "-"
  );

  /* ----------------------------
     SAVE FILE
  ----------------------------- */
  const filename = `newStarterPayroll_${userId}.pdf`;
  pdf.save(filename);
};







  if (loading) {
    return <div style={{ padding: 20 }}>Loading…</div>;
  }
  if (!data) {
    return <div style={{ padding: 20 }}>Form not found.</div>;
  }

  return (
    <div style={{ padding: 20, maxWidth: 900, margin: "0 auto" }}>
      <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>
        {data.name || "Form"} – Admin Review
      </h2>
      <p style={{ fontSize: 13, color: "#4b5563", marginBottom: 12 }}>
        User: <strong>{userId}</strong> | Document ID: <strong>{docId}</strong>
      </p>

      <div
        style={{
          background: "white",
          border: "1px solid #e5e7eb",
          borderRadius: 12,
          padding: 16,
          marginBottom: 16,
        }}
      >
        {Object.entries(data).map(([key, value]) => {
          if (
            [
              "name",
              "renewal",
              "status",
              "verified",
              "lastUpdated",
              "verifiedAt",
              "signature",
            ].includes(key)
          )
            return null;
          return (
            <div
              key={key}
              style={{
                display: "flex",
                marginBottom: 6,
                fontSize: 13,
                borderBottom: "1px solid #f3f4f6",
                paddingBottom: 4,
              }}
            >
              <div style={{ width: 180, fontWeight: 500 }}>{key}</div>
              <div style={{ flex: 1 }}>{String(value ?? "")}</div>
            </div>
          );
        })}

        {data.signature && (
          <div style={{ marginTop: 12 }}>
            <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 4 }}>
              Signature
            </div>
            <img
              src={data.signature}
              alt="Signature"
              style={{
                border: "1px solid #d1d5db",
                borderRadius: 8,
                maxWidth: 300,
              }}
            />
          </div>
        )}
      </div>

      <div style={{ display: "flex", gap: 10 }}>
        <button
          type="button"
          onClick={downloadPdf}
          style={{
            padding: "8px 14px",
            borderRadius: 9999,
            border: "none",
            background: "#4b5563",
            color: "white",
            fontSize: 13,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Download PDF
        </button>
        <button
          type="button"
          onClick={markVerified}
          style={{
            padding: "8px 14px",
            borderRadius: 9999,
            border: "none",
            background: "#16a34a",
            color: "white",
            fontSize: 13,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Mark Verified
        </button>
        <button
          type="button"
          onClick={markRejected}
          style={{
            padding: "8px 14px",
            borderRadius: 9999,
            border: "1px solid #b91c1c",
            background: "white",
            color: "#b91c1c",
            fontSize: 13,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Mark Rejected
        </button>
      </div>
    </div>
  );
}
